import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tos-de',
  templateUrl: './tos-de.component.html',
  styleUrls: ['./tos-de.component.scss']
})
export class TosDeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
